import { FieldFunctionOptions } from '@apollo/client';
import { TypePolicies } from '@apollo/client';

type GetListFolderQueryArgs = {
  folderId: number;
};

type ListDefinitionQueryArgs = {
  listId: number;
};

type ObjectTypeDefinitionQueryArgs = {
  objectType: string;
};

const cacheQueryPolicies: TypePolicies = {
  /**
   * redirects queries to existing objects in cache to prevent fetching
   * something that we already have
   *
   * example: if we already have a folder with the same ID we're calling
   * getListFolder with, we should get that folder from the cache instead of
   * fetching
   *
   * apollo docs:
   * https://www.apollographql.com/docs/react/caching/advanced-topics/#cache-redirects-using-field-policy-read-functions
   */
  Query: {
    fields: {
      getListFolder(_: unknown, { args, toReference }: FieldFunctionOptions) {
        const { folderId } = args as GetListFolderQueryArgs;
        return toReference({
          __typename: 'Folder',
          id: folderId,
        });
      },
      listDefinition(_: unknown, { args, toReference }: FieldFunctionOptions) {
        const { listId } = args as ListDefinitionQueryArgs;
        return toReference({
          __typename: 'ListDefinition',
          id: listId,
        });
      },
      objectTypeDefinition(
        _: unknown,
        { args, toReference }: FieldFunctionOptions
      ) {
        const { objectType } = args as ObjectTypeDefinitionQueryArgs;
        return toReference({
          __typename: 'ObjectTypeDefinition',
          id: objectType,
        });
      },
    },
  },
};

export default cacheQueryPolicies;
